import { useFeatureFlagEnabled } from "@posthog/react";
import {
  devOverridesEnabled,
  useDevOverridesStore,
  type MentorProfileOverride,
} from "@/lib/hooks/admin/use-dev-overrides";

export const MENTOR_PROFILE_FLAG = "mentor-profile";

export function resolveMentorProfileEnabled(params: {
  flagEnabled: boolean;
  override: MentorProfileOverride;
  overridesEnabled: boolean;
}): boolean {
  const { flagEnabled, override, overridesEnabled } = params;

  if (overridesEnabled) {
    switch (override) {
      case "on":
        return true;
      case "off":
        return false;
      case "default":
        break;
      default: {
        const _exhaustive: never = override;
        return _exhaustive;
      }
    }
  }

  return flagEnabled;
}

export function useMentorProfileEnabled(): boolean {
  const flagEnabled =
    useFeatureFlagEnabled(MENTOR_PROFILE_FLAG) ?? import.meta.env.DEV;
  const override = useDevOverridesStore((s) => s.mentorProfileOverride);

  return resolveMentorProfileEnabled({
    flagEnabled,
    override,
    overridesEnabled: devOverridesEnabled,
  });
}
